import * as constants from './constants';

const initialState = {
  allLearnerCamps: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const learnerStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_LEARNER_CAMPS:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_LEARNER_CAMPS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allLearnerCamps: [...state.allLearnerCamps, action.data],
        isAdding: false,
      };
    case constants.CREATE_LEARNER_CAMPS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_LEARNER_CAMPS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_LEARNER_CAMPS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allLearnerCamps: action.data,
      };
    case constants.UPDATE_ORDER_LEARNER_CAMPS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_LEARNER_CAMPS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_LEARNER_CAMPS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allLearnerCamps: action.data,
        isAdding: false,
      };
    case constants.FETCH_LEARNER_CAMPS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_LEARNER_CAMPS:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_LEARNER_CAMPS_SUCCESS:
      const updated = state.allLearnerCamps.map((el) =>
        el.id === action.data.id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allLearnerCamps: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_LEARNER_CAMPS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_LEARNER_CAMPS:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_LEARNER_CAMPS_SUCCESS:
      const updatedData = state.allLearnerCamps.filter(
        (el) => el.id !== action.data
      );
      return {
        ...state,
        allLearnerCamps: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_LEARNER_CAMPS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default learnerStatusReducer;
